// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.dashboard-comments-box {\n  background-color: #f9f9f9;\n  border-left: 4px solid #cb2a2a;\n  padding: 1rem;\n  border-radius: 8px;\n  color: #333;\n  font-size: 15px;\n  white-space: normal;\n  word-break: break-word;\n  line-height: 1.5;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
